<template>
  <div>
    <section v-show="details != ''" class="content">
      <h3>{{ details.user_name }}</h3>
      <ul>
        <li>
          <label>手机号码：</label>
          <p>{{ details.phone }}</p>
        </li>
        <li>
          <label>身份证号：</label>
          <p>{{ details.idcard }}</p>
        </li>
        <li>
          <label>项目：</label>
          <p>{{ details.project_name }}</p>
        </li>
        <li>
          <label>入职岗位：</label>
          <p>{{ details.role_name }}</p>
        </li>
        <li>
          <label>所属门店：</label>
          <p>{{ details.shop_name }}</p>
        </li>
        <li>
          <label>计薪方式：</label>
          <span
            v-show="
              details.guard_config != undefined &&
                details.guard_config.guard_count_type == 1
            "
            >单价</span
          >
          <span
            v-show="
              details.guard_config != undefined &&
                details.guard_config.guard_count_type == 2
            "
            >时薪</span
          >
          <span
            v-show="
              details.guard_config != undefined &&
                details.guard_config.guard_count_type == 3
            "
            >底薪</span
          >
        </li>
        <li>
          <label>结算价：</label>
          <span
            v-if="
              details.guard_config != undefined &&
                details.guard_config.guard_count_type == 1
            "
            >{{ Number(details.guard_config.guard_price) + "元/单" }}</span
          >
          <span
            v-if="
              details.guard_config != undefined &&
                details.guard_config.guard_count_type == 2
            "
            >{{
              Number(details.guard_config.guard_time_price) + "元/小时"
            }}</span
          >
          <span
            v-if="
              details.guard_config != undefined &&
                details.guard_config.guard_count_type == 3
            "
            >{{ Number(details.guard_config.guard_base_salary) + "元" }}</span
          >
        </li>
      </ul>
    </section>
  </div>
</template>
<script>
export default {
  data() {
    return {
      details: {}
    };
  },
  props: {
    detailsVal: {}
  },
  watch: {
    detailsVal() {
      this.getDetails();
    }
  },
  mounted() {
    if (this.detailsVal != undefined) {
      this.getDetails();
    }
  },
  methods: {
    getDetails() {
      this.details = this.detailsVal;
      console.log(this.details);
    }
  }
};
</script>
<style lang="less" scoped>
.content {
  margin: 30px 2%;
  h3 {
    font-size: 24px;
    font-weight: normal;
  }
  ul {
    li {
      display: inline-block;
      width: 33.3%;
      margin-bottom: 10px;
      label,
      p {
        display: inline-block;
        vertical-align: top;
        font-size: 14px;
        line-height: 20px;
      }
      p {
        max-width: 70%;
      }
    }
  }
}
</style>
